import { Currency, Country, CURRENCY_KEY, COUNTRY_KEY } from '../constants';
import Cookies from 'js-cookie';

export const getCurrencyCookie = () => {
  return Cookies.get(CURRENCY_KEY) as Currency | undefined;
};
export const getCountryCookie = () => {
  return Cookies.get(COUNTRY_KEY) as Country | undefined;
};

export const setCurrencyCookie = (currency: Currency) => {
  Cookies.set(CURRENCY_KEY, currency);
};
export const setCountryCookie = (country: Country) => {
  Cookies.set(COUNTRY_KEY, country);
};

/**
 * Formats amount with the appropriate currency symbol based on the country.
 * @param {string} country - The name of the country.
 * @param {number|string} amount - The amount to format.
 * @returns {string} - The formatted amount with currency symbol.
 */

export function formatCurrency(country: Currency, amount: number | string): string {
  const decimalsByCurrency: Partial<Record<Currency, number>> = {
    [Currency.Japan]: 0,
  };
  const decimals = decimalsByCurrency[country] ?? 2;
  const formattedAmount = Number(amount).toFixed(decimals);

  const currencyInfo: Record<Currency, { symbol: string; position: 'prefix' | 'suffix' }> = {
    [Currency.Australia]: { symbol: 'A$', position: 'prefix' },
    [Currency.Canada]: { symbol: 'CA$', position: 'prefix' },
    [Currency.Malaysia]: { symbol: 'RM', position: 'prefix' },
    [Currency.NewZealand]: { symbol: 'NZ$', position: 'prefix' },
    [Currency.Qatar]: { symbol: 'ر.ق', position: 'suffix' },
    [Currency.SaudiArabia]: { symbol: 'ر.س', position: 'suffix' },
    [Currency.Singapore]: { symbol: 'S$', position: 'prefix' },
    [Currency.UnitedArabEmirates]: { symbol: 'د.إ', position: 'suffix' },
    [Currency.UnitedKingdom]: { symbol: '£', position: 'prefix' },
    [Currency.UnitedStates]: { symbol: '$', position: 'prefix' },
    [Currency.Europe]: { symbol: '€', position: 'prefix' },
    [Currency.Poland]: { symbol: 'zł', position: 'prefix' },
    [Currency.Turkey]: { symbol: '₺', position: 'prefix' },
    [Currency.Kazakhstan]: { symbol: '₸', position: 'prefix' },
    [Currency.Mongolia]: { symbol: '₮', position: 'prefix' },
    // [Currency.Uzbekistan]: { symbol: 'UZS', position: 'prefix' },
    [Currency.Azerbaijan]: { symbol: '₼', position: 'prefix' },
    [Currency.Switzerland]: { symbol: 'CHF', position: 'prefix' },
    [Currency.Denmark]: { symbol: 'kr.', position: 'prefix' },
    [Currency.Norway]: { symbol: 'kr', position: 'prefix' },
    [Currency.Japan]: { symbol: '¥', position: 'prefix' },
  };

  if (!currencyInfo[country]) {
    return formattedAmount.toString();
  }

  const { symbol, position } = currencyInfo[country];

  if (position === 'prefix') {
    return `${symbol}${formattedAmount}`;
  } else {
    return `${formattedAmount} ${symbol}`;
  }
}
